import { render, staticRenderFns } from "./question-08.vue?vue&type=template&id=2659b4e6&scoped=true&lang=pug"
var script = {}
import style0 from "./question-08.vue?vue&type=style&index=0&id=2659b4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659b4e6",
  null
  
)

export default component.exports